import { render, staticRenderFns } from "./adminlogisticsInvPortal.vue?vue&type=template&id=b3a0d5de&scoped=true"
import script from "./adminlogisticsInvPortal.vue?vue&type=script&lang=js"
export * from "./adminlogisticsInvPortal.vue?vue&type=script&lang=js"
import style0 from "./adminlogisticsInvPortal.vue?vue&type=style&index=0&id=b3a0d5de&prod&lang=css"
import style1 from "./adminlogisticsInvPortal.vue?vue&type=style&index=1&id=b3a0d5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a0d5de",
  null
  
)

export default component.exports